export function buildPersonasPorAlergeno({ alergenos, personas }) {
    const map = {};
    for (const al of alergenos || []) map[al.id] = [];

    for (const p of personas || []) {
        const ids = new Set((p.alergenos || []).map((a) => a.id));
        for (const al of alergenos || []) {
            if (ids.has(al.id)) map[al.id].push(p);
        }
    }
    return map;
}

export function applyAlergenosFilter({
    alergenos,
    personasPorAlergeno,
    q,
    soloConPersonas,
    sortBy,
}) {
    const text = (q || "").trim().toLowerCase();

    const list = (alergenos || []).filter((al) => {
        const alName = (al.alergenoDescripcion || al.alergeno || "").toLowerCase();
        const matchAl = !text || alName.includes(text);

        const persons = personasPorAlergeno[al.id] || [];
        const matchPerson =
            !text ||
            persons.some((p) =>
                [p.nombre, p.apellidos, p.nickname, p.email]
                    .filter(Boolean)
                    .some((v) => String(v).toLowerCase().includes(text))
            );

        const passText = matchAl || matchPerson;
        const passPeople = !soloConPersonas || persons.length > 0;
        return passText && passPeople;
    });

    if (sortBy === "conteo") {
        return list.sort(
            (a, b) =>
                (personasPorAlergeno[b.id]?.length || 0) - (personasPorAlergeno[a.id]?.length || 0)
        );
    }

    return list.sort((a, b) =>
        String(a.alergenoDescripcion || a.alergeno || "").localeCompare(
            String(b.alergenoDescripcion || b.alergeno || "")
        )
    );
}

export function computeKpis({ filtered, personas, personasPorAlergeno }) {
    const totalAlergenos = (filtered || []).length;
    const totalPersonas = (personas || []).length;
    const totalVinculos = (filtered || []).reduce(
        (s, al) => s + (personasPorAlergeno[al.id]?.length || 0),
        0
    );

    return { totalAlergenos, totalPersonas, totalVinculos };
}
